import { useGameState } from '@/pages/tmt-spick/hooks/useGameState';
import { useViewportMetrics } from '@/pages/tmt-spick/hooks/useViewportMetrics';
import TopBar from '@/pages/tmt-spick/components/TopBar';
import GuideScreen from '@/pages/tmt-spick/components/GuideScreen';
import GameScreen from '@/pages/tmt-spick/components/GameScreen';
import ResultScreen from '@/pages/tmt-spick/components/ResultScreen';
import ExitConfirmModal from '@/pages/tmt-spick/components/ExitConfirmModal';
import {
  STAGE1_CONFIG,
  STAGE2_CONFIG,
  STAGE3_CONFIG,
} from '@/pages/tmt-spick/tmtConfig';

// 스픽(Spick) 인앱용 순서 잇기 (TMT) 버전
// 플로우: 게임 소개 → 1~3단계 → 결과 (연습 단계 없음)
// 화면 구성/공통 UI(상단바·게임 배경·결과 화면)는 다른 스픽 버전과 동일한 시스템을 사용한다.
export default function TmtSpick() {
  // 실제 가용 높이를 측정해 CSS 변수(--sh-app-height 등)로 주입한다
  useViewportMetrics();

  const {
    screen,
    showExitModal,
    path,
    wrongId,
    completed,
    transitionMsg,
    remainingMs,
    score,
    totalTimeMs,
    totalWrongCount,
    startGame,
    handleSelect,
    openExitModal,
    closeExitModal,
    confirmExit,
    goToGuide,
    goToNext,
  } = useGameState();

  const isPlaying =
    screen === 'stage1' ||
    screen === 'stage2' ||
    screen === 'stage3';

  // 게임 소개(진입) 화면에서는 상단바를 렌더링하지 않는다
  const isEntry = screen === 'guide';
  // 결과 화면은 스픽 그라데이션 배경을 사용한다 (상단바 영역까지 이어짐)
  const isResult = screen === 'result';

  // WebView 네비게이션과 충돌하지 않도록 게임 정보 없이 뒤로/홈만 배치
  const handleBack = () => {
    if (isPlaying) {
      openExitModal();
      return;
    }
    goToGuide();
  };

  const handleHome = () => {
    if (isPlaying) {
      openExitModal();
      return;
    }
    goToGuide();
  };

  return (
    <div className="spick-scope w-full bg-white flex justify-center">
      <div
        className={`w-full max-w-[430px] flex flex-col relative overflow-hidden game-no-scroll ${
          isResult ? 'sh-result-bg' : 'bg-white'
        }`}
        /* 100dvh 기준: 브라우저 주소창/하단 메뉴가 바뀌어도 실제 가용 높이를 사용한다. */
        style={{ height: 'var(--sh-app-height, 100dvh)' }}
      >
        {!isEntry && (
          <TopBar
            onBack={handleBack}
            onHome={handleHome}
            /* 게임 화면에서는 헤더부터 하단까지 BG 컬러 레이어가 이어지고,
               결과 화면에서는 그라데이션 배경이 상단바 뒤로 이어지도록 투명 처리 */
            backgroundClassName={isPlaying ? 'sh-game-bg' : isResult ? 'bg-transparent' : 'bg-white'}
          />
        )}

        <div className="flex-1 min-h-0 overflow-hidden">
          {screen === 'guide' && <GuideScreen onStart={startGame} />}
          {screen === 'stage1' && (
            <GameScreen
              config={STAGE1_CONFIG}
              path={path}
              wrongId={wrongId}
              completed={completed}
              remainingMs={remainingMs}
              transitionMsg={transitionMsg}
              onSelect={handleSelect}
            />
          )}
          {screen === 'stage2' && (
            <GameScreen
              config={STAGE2_CONFIG}
              path={path}
              wrongId={wrongId}
              completed={completed}
              remainingMs={remainingMs}
              transitionMsg={transitionMsg}
              onSelect={handleSelect}
            />
          )}
          {screen === 'stage3' && (
            <GameScreen
              config={STAGE3_CONFIG}
              path={path}
              wrongId={wrongId}
              completed={completed}
              remainingMs={remainingMs}
              transitionMsg={transitionMsg}
              onSelect={handleSelect}
            />
          )}
          {screen === 'result' && (
            <ResultScreen
              score={score}
              totalTimeMs={totalTimeMs}
              wrongCount={totalWrongCount}
              onRetry={startGame}
              onNext={goToNext}
            />
          )}
        </div>

        <ExitConfirmModal
          isOpen={showExitModal}
          onConfirm={confirmExit}
          onCancel={closeExitModal}
        />
      </div>
    </div>
  );
}